import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";
import { TicketDialog } from "../TicketDialog";
import BlockUi from "react-block-ui";
import { TicketUploadDialog } from "../TicketUploadDialog";
import { Formatter, isNullOrEmpty, isNullOrUndefined } from "../Util";

const Settings = {
	ShowDateFilter: true,
	DateColumn: "date_entered",
	SortColumn: "sort_by",
	UseTicketTypeFilter: true,
	ShowGlobalFilter: true,
};

const ticketTypes = [
	{ ticket_types_id: "1DB19C7D-F075-4BBC-A763-7A045E11AF16", description: "Maintenance" },
	{ ticket_types_id: "DE11396C-340B-418E-B62D-8B0E1072248D", description: "Repair" },
	{ ticket_types_id: "C4F9E5F9-1FFC-413A-88BB-202BCC95CB55", description: "Call Back" },
	{ ticket_types_id: "2DF67000-F308-4D81-B247-182C8CB08098", description: "Violation" },
	{ ticket_types_id: "A9FA81E3-2A24-4F23-805F-EC943C58DBB8", description: "Open Order" },
	{ ticket_types_id: "9D13704F-808B-4267-A35F-245C7CB26D8D", description: "Sale" },
	{ ticket_types_id: "CD874196-C3E0-40E5-B0A2-938546298756", description: "Nuisance" },
];
class TicketListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Tickets: [],
			TicketType: props.TicketType,
			Recommendations: props.Recommendations || false,
			ModalVisible: false,
			TicketData: null,
			Loading: true,
			ShowUploadDialog: false,
			Filters: {}
		};
		this.getData = this.getData.bind(this)
		this.getData();
		this.CloseTicket = this.CloseTicket.bind(this);
		this.CloseUploadTicket = this.CloseUploadTicket.bind(this);
		Settings.ShowTicketTypeFilter = props.TicketType === "" || props.TicketType === null;

		if (!this.props.IsClientPortal) {
			this.addTicket = this.addTicket.bind(this);
			Settings.NewButtonAction = this.addTicket;
			Settings.NewButtonText = "Add Ticket";
		}
	}

	CloseUploadTicket() {
		this.setState({ ShowUploadDialog: false });
		this.getData();
	}

	async MarkSaleComplete(row) {
		await fetch("Ticket/CompleteSale", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ticketsId: row["tickets_id"] }),
		});

		this.getData();
	}

	addTicket() {
		this.setState({ ShowUploadDialog: true, UploadTicketID: null });
	}

	async markTicketViewed(row) {
		await fetch("Ticket/MarkTicketViewed", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(row["tickets_id"]),
		});

		this.getData();
	}

	async MarkEstimateSent(row) {
		await fetch("Ticket/MarkEstimateSent", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ticketsId: row["tickets_id"] }),
		});

		this.getData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingID !== prevProps.BuildingID) {
			this.getData();
		}
	}

	async getData(pageNumber, pageSize, dateFilter, ticketTypeFilter, globalFilter, orderBy) {
		var filt = this.state.Filters;
		if (!orderBy) {
			orderBy = filt.OrderBy || [{ "ColumnName": "ticket_number", "IsDescending": true }]
		}
		filt.OrderBy = orderBy;

		pageNumber = isNullOrUndefined(pageNumber) ? filt.PageNumber || 0 : pageNumber;
		filt.PageNumber = pageNumber

		pageSize = pageSize || filt.PageSize || 10;
		filt.PageSize = pageSize;

		const types = []
		if (!isNullOrUndefined(this.state.TicketType)) {
			types.push(this.state.TicketType);
		}
		else {
			if (ticketTypeFilter)
				(ticketTypeFilter || []).forEach(x => types.push(ticketTypes.find(y => y.description === x).ticket_types_id))
			else if (filt.Types)
				filt.Types.forEach(x => types.push(x));
		}


		let dt = dateFilter ? Formatter(dateFilter, "D") : (filt.DateFilter || null);
		if (dt === "01/01/1900" || dt === "Invalid date")
			dt = null;

		filt.DateFilter = dt;


		if (this.props.SaleTicket) {
			types.push("CD874196-C3E0-40E5-B0A2-938546298756")
		}
		filt.Types = types;
		this.setState({ Loading: true, Filters: filt })

		const data = await fetch("Ticket/GetPagedTickets", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				buildingId: this.props.BuildingID || undefined,
				ticketTypeId: types,
				recommendations: this.state.Recommendations,
				pageNumber: pageNumber,
				pageSize: pageSize,
				orderBy: orderBy,
				ticketDate: dt,
				globalFilter: globalFilter
			}),
		});
		var res = await data.json();
		this.setState({ Tickets: res, Loading: false });
	}

	ShowTicket(row) {
		console.log(row);
		if (!row.is_pdf_data) this.setState({ ModalVisible: true, TicketData: row });
		else {
			this.setState({ ShowUploadDialog: true, UploadTicketID: row.tickets_id });
		}
	}

	CloseTicket() {
		this.setState({ ModalVisible: false, TicketData: {} });
		this.getData();
	}

	render() {
		const config = [
			{
				header: "Building Name",
				columnName: "building_name",
				visible: true,
				typeCode: "S",
			},
			{
				header: "Serial Number",
				columnName: "serial_number",
				visible: true,
				typeCode: "S",
			},
			{
				header: "Ticket Number",
				columnName: "ticket_number",
				visible: true,
				typeCode: "N",
			},
			{
				header: "Date",
				columnName: "date_entered",
				visible: true,
				typeCode: "D",
			},
			{
				header: "Type",
				columnName: "ticket_types",
				visible: !this.state.Recommendations,
				typeCode: "S",
			},
			{
				header: "Recommendations",
				columnName: "recommendation",
				visible: this.state.Recommendations,
				typeCode: "S",
			},
			{ header: "Submitted?", columnName: "is_submitted", typeCode: "L", visible: true },
			{
				header: "Mark Sent",
				columnName: "mark_sent",
				visible: this.state.Recommendations,
				OnClick: (row) => this.MarkEstimateSent(row),
				typeCode: "ACTION",
				style: { minWidth: "147px" },
			},
			{
				header: "Complete Sale",
				columnName: "complete_sale",
				visible: this.props.SaleTicket || false,
				OnClick: (row) => this.MarkSaleComplete(row),
				typeCode: "ACTION",
			},
			{
				header: "Mark Viewed",
				columnName: "mark_viewed",
				visible: !this.props.IsClientPortal,
				OnClick: (row) => this.markTicketViewed(row),
				typeCode: "ACTION",
			},
		];
		Settings.ShowNewButton = !this.props.IsClientPortal && !isNullOrEmpty(this.props.BuildingID);
		return (
			<BlockUi blocking={this.state.Loading} tag="div" style={{ maxHeight: "100%" }}>
				<div
					style={{
						flex: 1,
						minHeight: "500px",
						backgroundColor: "#ebebeb",
						overflowY: "auto",
						padding: "4px",
						maxHeight: "100%",
					}}>
					<TicketDialog IsClientPortal={this.props.IsClientPortal} Visible={this.state.ModalVisible} TicketsID={(this.state.TicketData ? this.state.TicketData : {}).tickets_id} OnClose={this.CloseTicket} TicketData={this.state.TicketData}></TicketDialog>
					<TicketUploadDialog BuildingID={this.props.BuildingID} TicketID={this.state.UploadTicketID} IsClientPortal={this.props.IsClientPortal} Visible={this.state.ShowUploadDialog} TicketsID={(this.state.TicketData ? this.state.TicketData : {}).tickets_id} OnClose={this.CloseUploadTicket} TicketData={this.state.TicketData}></TicketUploadDialog>
					<DynamicGrid Refresh={this.getData} UseDbFilterAndSort={true} Configuration={config} DataSet={this.state.Tickets} Settings={Settings} OnRowClick={(row) => this.ShowTicket(row)} ShowTicketTypeFilter={!this.state.TicketType} />
				</div>
			</BlockUi>
		);
	}
}

TicketListing.propTypes = {
	BuildingID: PropTypes.string,
	TicketType: PropTypes.string,
};

export default TicketListing;
